import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { Tabs } from 'antd';
import MakeEvent from './MakeEvent';
import ManageCategories from './ManageCategories'
import ManageLeagues from './ManageLeagues'
import ManageTeams from './ManageTeams'
import ManageLeaders from './ManageLeaders'
@observer(["ViewStore", "UserStore"])
class AdminPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }

    async componentWillMount() {
        this.props.ViewStore.changeView('Admin');
        this.props.ViewStore.changeCurrentPage('Admin')
    }
    componentWillUnmount() {
        this.props.ViewStore.changePreviousPage('Admin')
    }

    render() {
        const { UserStore } = this.props;
        const TabPane = Tabs.TabPane;

        return (
            <div className="admin-container">
                <h1>Admin Panel</h1>
                <div className="admin-tabs-container">
                    {this.props.UserStore.user.role == "admin" ?
                        <Tabs defaultActiveKey="1">
                            <TabPane tab="Make Event" key="1"><MakeEvent /></TabPane>
                            <TabPane tab="Categories" key="2"><ManageCategories /></TabPane>
                            <TabPane tab="Leagues" key="3"><ManageLeagues /></TabPane>
                            <TabPane tab="Teams" key="4"><ManageTeams /></TabPane>
                            {/* <TabPane tab="Leaders" key="5"><ManageLeaders /></TabPane> */}
                        </Tabs>
                        :
                        null
                    }
                </div>
            </div>
        );
    }
}

export default AdminPanel;


// WEBPACK FOOTER //
// ./src/components/appComponents/admin/AdminPanel.js